import type { WhatsNewItem } from '@platform/client/features/feature-config';

import { Stack } from '@packages/fenrir/components/stack';

import { OrganizationSwitcher } from './organization-switcher';
import type { AppSwitchMenuItem } from './toolbar/app-switch-menu';
import { ToolbarActions } from './toolbar/toolbar-actions';

export const AppBar = ({
  appSwitchItems,
  whatsNew,
}: {
  appSwitchItems: AppSwitchMenuItem[];
  whatsNew: WhatsNewItem[];
}) => {
  return (
    <Stack
      direction="row"
      sx={{ alignItems: 'center', justifyContent: 'space-between', flex: 1 }}
    >
      <OrganizationSwitcher />
      <ToolbarActions appSwitchItems={appSwitchItems} whatsNew={whatsNew} />
    </Stack>
  );
};
